export enum Common {
  List = 'byAv',
  OK = 'VlM5',
  Ok = 'hDrA',
  Less = 'rlI5',
  More = '1H18',
  Back = 'dpAP',
  Done = 'EaZ2',
  No = 'HqRC',
  Yes = 'haOa',
  Checked = 'Dv2S',
  Exit = '0X2E',
  Close = 'fZ63',
  AutoRestock = 'voaZ',
  AddSitesBrackets = 'SAe2',
  SaveChanges = 'NTIr',
  DiscardAllUnsavedChanges = 'Ngk+',
  SelectEvent = 'KOy1',
  SelectSiteAndEvent = 'RCj3',
  SelectEventAndSite = 'c87q',
  Print = '3w/n',
  print = 'zpU6',
  export = '1Gru',
  ExportPDF = 'eq2d',
  ExportCSV = 'kfcc',
  PrintSheets = 'laiz',
  PrintWrittenSheet = 'SBM1',
  Cancel = 'GXZu',
  Duplicate = 'As2q',
  Submit = 'FV+B',
  SaveAndNew = 'jW3j',
  SaveAndClose = 'dUFG',
  SubmitAndNew = '+BrE',
  Reopen = 'qIbR',
  Accept = 'iXE7',
  Reject = 'q2BK',
  Edited = 'cRfw',
  ToggleDropdown = '+2ss',
  Apply = 'MeOS',
  Reset = '2u52',
  Search = 'ScJm',
  Refresh = 'DpFh',
  MakeDefault = 'feEG',
  Actions = '/4BZ',
  AddItems = 'iOzr',
  AddItemsBrackets = 'ZA6X',
  AddAfter = 'h7f9',
  AddBefore = 'fwCF',
  DeletedItemsListView = 'lsbl',
  ViewDetails = 'kHic',
  MoveToBottom = 'iav6',
  MoveToTop = '22D3',
  Remove = 'w4Ev',
  Collapse = 'vm6x',
  Expand = 'B1SM',
  ShowAll = '4cMm',
  Save = 'FQn1',
  save = 'FX3K',
  Delete = '4tCl',
  Continue = 'Mfvv',
  Complete = 'FDsn',
  Previous = 'pXsI',
  Next = 'H/V6',
  Create = 'R1lJ',
  Edit = 'RkxP',
  EditMode = 'oYLy',
  View = '3Mg5',
  NewEntity = 'k5WI',
  All = 'pSrO',
  SelectAll = '0exp',
  DeselectAll = 'XNJh',
  NoRowsToShow = 'FIbE',
  NoItemsToDisplay = 'Mnuk',
  NoItemsToDisplayUpper = 'cWLv',
  CollapseAll = 'VZiO',
  ExpandAll = 'n1sC',
  DefaultView = '+M8b',
  Page = 'CjCo',
  of = 'KDkd',
  NoOptions = 'IOT5',
  SearchMore = 'f1U4',
  GrandTotal = 'IPP5',
  Status = 'kg5B',
  DeliveryDate = 'C3/q',
  Discard = '6xpw',
  General = 'yRDU',
  Created = '1wue',
  created = 'QG7/',
  LastUpdated = 'OCrF',
  lastUpdated = 'DvBq',
  SelectColumns = '6T6l',
  SelectColumnsToExport = 'q3uN',
  Totals = 'a9bf',
  SelectFrom = 'xoTq',
  SelectTo = '72eq',
  From = 'IYGX',
  from = 'dYV6',
  To = '9LBu',
  to = 'Zj6h',
  Date = 'mcQK',
  DateTime = 'AY+9',
  SelectDate = 'ZetS',
  Period = 'bnld',
  PreviousPeriod = 'yisX',
  CurrentPeriod = 'Ujgw',
  AnyOfTheFollowing = '7lHO',
  AnyOfTheFollowingString = '7lHO6',
  ItemThatDirectlyEqualWithCondition = 'b8pL',
  ExactValue = 'JrBt',
  AllOfTheFollowing = 'YdWN',
  NoneOfTheFollowing = 'GGq6',
  DateRange = 'FNdB',
  DateTimeRange = 'iJuB',
  Amount = 'Selt',
  Range = 'XedK',
  Mappings = '9k7B',
  GreaterThan = 'H7yt',
  LessThan = 'IxBb',
  GreaterThanOrEqual = 'rCW4',
  LessThanOrEqual = 'rupz',
  InRange = 'Glhu',
  Confirm = '7r3S',
  SUCCESS = '4qis',
  Success = 'yIoL',
  Failure = 'cDHt',
  ERROR = '2Y7g',
  Error = 'VKDo',
  WARNING = 'hvVv',
  Prompt = 'XDkS',
  SelectXEntities = 'bpZv',
  SelectEntities = 'oJE0',
  SiteSelector = 'e62e',
  POS = 'rpjq',
  Portal = 'tl/+',
  All_Sources = 'uHfp',
  NextXEvents = 'iolo',
  TileSelector = '9pK/',
  TileName = '8hv1',
  NA = '4vee',
  Source = 'DlcM',
  Total = 'ybPD',
  ToSite = 'PGj6',
  Type = 'uq3f',
  TimeCreated = 'TGiV',
  TimeSent = 'XUIM',
  Clear = 'g7Es',
  cancel = 'I3TZ',
  submit = 'dUkL',
  accept = 'wSXQ',
  approve = 'dOIW',
  reopen = 'LfO+',
  void = 'RFvl',
  remove = 'flYI',
  duplicate = '4kpa',
  edit = 'JiEh',
  reject = 'CE6Z',
  view = 'K8tD',
  Chargeable = 'tVZ8',
  Approve = 'YAes',
  SaveAndReopen = 'wkre',
  Name = '3NHV',
  NoMatches = 'uld3',
  AddNewBrackets = '10am',
  GrandTotals = 'lRoW',
  SiteCounts = 'sbLE',
  CategoryView = 'pQPS',
  AlphabeticalListView = 'IHXd',
  ExportByMajorCategory = 'QuY0',
  ExportByConsolidatedCategory = 'VUqH',
  Export = 'NmSJ',
  MeasureName = 'hFyG',
  Count = 'N7rE',
  InventoryItemCost = 'Xi/4',
  QOH = '5Aap',
  ManagerCount = 'wrod',
  UOM = 'uJQ2',
  Filter = 'Y44k',
  ViewSetting = 'TVe8',
  EnterANameForEntity = 'WyAz',
  PAR = 'WVEK',
  MINQty = 'itMD',
  Minimum = 'c1vu',
  HideEmptyRows = '/f77',
  Item = 'ZSvM',
  BackTo = 'zZGC',
  EntityNameDetails = 'cs7v',
  Location = 'FbYZ',
  Initials = 'MUvx',
  Countedby = 'EDoR',
  Recordedby = 'zryN',
  Enteredby = 'YEb6',
  SwitchSite = 'y0Am',
  Concessions = 'KsfM',
  Premium = '3ojB',
  Suites = 'o1Qw',
  Other = '+X6d',
  NotConfigured = 'u+qW',
  And = 'D2dR',
  SelectSitesWithBracket = 'Sbiu',
  Unknown = 't2TN',
  by = 'p+LS',
  Normal = 'pySO',
  Reversals = 'p8d6',
  Operator = 'KREB',
  Changed = 'KmFB',
  UpdateForm = '29dg',
  Maximum = 'Zsmr',
  SaveAndSubmit = 'kswA',
  CountsWithBrackets = 'W/7F',
  ByConsolidatedCategory = 'Y0Kt',
  ByMajorCategory = '0vpZ',
  ReInitialize = 'c16L',
  ReInitialized = '4Mny',
  reinitialize = 'Yy3y',
  ClickHereToCompleteThem = 'wOlx',
  AutoRefreshingTemporarilyPauses = 'HfP7',
  PleaseViewDetails = 'JVLJ',
  Loading = '3DgI',
  the = 'uXdt',
  ExclamationMark = 'u3II',
  PeriodWithSpace = 'jczy',
  Each = 'qVMf',
  UnhandledError = '2eqX',
  Text = 'cZiM',
  AddNewItem = 'JwKg',
  ItemSingular = 'SjPq',
  ItemsPlural = 'XzxP',
  character = 'S87z',
  characters = 'Jdk5',
  element = 'RFkp',
  elements = 'sLF4',
  Template = 'BXXy',
  Removed = 'QRj7',
  Notice = 'ZWWR',
  EverythingElse = 'bDfy',
  none = 'FAvt',
  PrimaryBrackets = 'WkNo',
  CountItem = 'i68/',
  CountItems = 'hTpA',
  RateWithBracket = 'O5/e',
  SignatureLines = 'aY/P',
  PulledBy = '/xOT',
  Signature = '8ac+',
  Notes = 'inUl',
  Varies = 'asVb',
  NoResultsFound = 'fs2/',
  Add = 'n9co',
}

export enum Application {
  Inventory = 'dY9I',
  VenuesInventory = 'f5cy',
  SearchInventory = '7l7H',
  Xenial = 'cqPD',
  Genius = '73ce',
  XenialPOS = 'ZwAz',
  GeniusEnterprisePOS = 'tNmW',
}

export enum Routes {
  TransferListTitle = 'gHlb',
  TransferRequestListTitle = 'CH5O',
  TransferGroupListTitle = 'mtxo',
  TransferGroupTemplateListTitle = 'VnY4',
  IncompleteTransferListTitle = 'Hg2Y',
  HistoricalTransferQuantityListTitle = '74IQ',
  InventoryOrderListTitle = 'xX/b',
  StandWorksheetListTitle = 'WIyB',
  InventoryCountListTitle = 'kQCk',
  SaleDepletionListTitle = 'qyvP',
  FilteredOrderListTitle = 'WEvi',
  FilteredTransferListTitle = '70eE',
  HawkerProfileListTitle = 'otb9',
}
